/**
 * A versão com que ESTE painel foi montado.
 *
 * Não é uma chamada ao servidor: o número é escrito dentro do arquivo montado, na hora de
 * montar, pelo `define` do `vite.config.ts`. Por isso ele é a versão da tela que o navegador
 * está mostrando, e não a do servidor que está respondendo.
 *
 * As duas são iguais no dia em que a versão sobe, porque nascem do mesmo `package.json`. Elas
 * se separam num caso só, e é um caso real: o navegador guardou a página de antes. Comparar os
 * dois números é o que deixa a tela de Sobre dizer "feche e abra o painel de novo" em vez de a
 * pessoa achar que o servidor não atualizou.
 */

/** Trocado por um texto na hora de montar. Ver o `define`, em `vite.config.ts`. */
declare const __VERSAO_DO_PAINEL__: string

export const VERSAO_DO_PAINEL = __VERSAO_DO_PAINEL__
